"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const helpers_1 = require("../../commonFiles/helpers");
const URLs_1 = require("../utility/URLs");
const react_bootstrap_1 = require("react-bootstrap");
const ImagePicker_1 = __importDefault(require("../components/ImagePicker"));
const react_router_1 = require("react-router");
const ContentTableEditor_1 = __importDefault(require("./components/ContentTableEditor"));
function BookCreator(props) {
    const [pages, setpages] = react_1.default.useState([]);
    const [content_table, setcontent_table] = react_1.default.useState([]);
    const [title, settitle] = react_1.default.useState('');
    const [description, setdescription] = react_1.default.useState('');
    const [about, setabout] = react_1.default.useState('');
    const [author, setauthor] = react_1.default.useState('');
    const [activated, setactivated] = react_1.default.useState(false);
    const [thumbnail, setthumbnail] = react_1.default.useState('');
    const [redirect, setredirect] = react_1.default.useState();
    function setup() {
        (0, helpers_1.ApiCallHandler)(() => __awaiter(this, void 0, void 0, function* () {
            return yield URLs_1.Api.fetchPages({
                // withoutContent: true, 
                withoutPagination: true
            });
        }), setpages, 'BookCreator fetchPages', false);
    }
    function submit() {
        (0, helpers_1.ApiCallHandler)(() => __awaiter(this, void 0, void 0, function* () { return yield URLs_1.Api.createBook(title, description, about, thumbnail, author, activated, content_table); }), (data) => { alert(data.success); setredirect(URLs_1.Routes.booksIndex()); }, 'BookCreator2 submit', true);
    }
    react_1.default.useEffect(() => {
        setup();
    }, []);
    react_1.default.useEffect(() => {
        console.log('BookCreator content_table', content_table);
    }, [content_table]);
    if (redirect)
        react_1.default.createElement(react_router_1.Redirect, { to: redirect });
    return react_1.default.createElement("div", { className: 'bg-white' },
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: 'my-2' },
                react_1.default.createElement("div", { className: 'fw-bold' }, "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0643\u062A\u0627\u0628"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { as: 'input', type: 'text', placeholder: '\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0643\u062A\u0627\u0628', onChange: e => settitle(e.target.value) })),
            react_1.default.createElement("div", { className: 'my-2' },
                react_1.default.createElement("div", { className: 'fw-bold' }, "\u0648\u0635\u0641 \u0627\u0644\u0643\u062A\u0627\u0628"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { as: 'textarea', type: 'text', placeholder: '\u0648\u0635\u0641 \u0627\u0644\u0643\u062A\u0627\u0628', onChange: e => setdescription(e.target.value) })),
            react_1.default.createElement("div", { className: 'my-2' },
                react_1.default.createElement("div", { className: 'fw-bold' }, "\u062D\u0648\u0644 \u0627\u0644\u0643\u062A\u0627\u0628"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { as: 'textarea', type: 'text', placeholder: '\u062D\u0648\u0644 \u0627\u0644\u0643\u062A\u0627\u0628', onChange: e => setabout(e.target.value) })),
            react_1.default.createElement("div", { className: 'my-2' },
                react_1.default.createElement("div", { className: 'fw-bold' }, "\u0645\u0624\u0644\u0641 \u0627\u0644\u0643\u062A\u0627\u0628"),
                react_1.default.createElement(react_bootstrap_1.Form.Control, { as: 'input', type: 'text', placeholder: '\u0645\u0624\u0644\u0641 \u0627\u0644\u0643\u062A\u0627\u0628', onChange: e => setauthor(e.target.value) })),
            react_1.default.createElement("div", { className: 'my-2' },
                react_1.default.createElement("div", { className: 'fw-bold' }, "\u062A\u0641\u0639\u064A\u0644 \u0627\u0644\u0639\u0631\u0636"),
                react_1.default.createElement("input", { checked: activated, type: 'checkbox', onChange: e => setactivated(e.target.checked) })),
            react_1.default.createElement("div", { className: 'my-2' },
                react_1.default.createElement("h5", null, "\u0635\u0648\u0631\u0629 \u0627\u0644\u063A\u0644\u0627\u0641"),
                react_1.default.createElement(ImagePicker_1.default, { setImage: base64 => setthumbnail(base64) }))),
        react_1.default.createElement("div", { className: 'mx-auto' },
            react_1.default.createElement("h3", { className: 'text-center' }, "\u062C\u062F\u0648\u0644 \u0627\u0644\u0645\u062D\u062A\u0648\u0649"),
            react_1.default.createElement(ContentTableEditor_1.default, { pages: pages, editContentTable: setcontent_table })),
        react_1.default.createElement(react_bootstrap_1.Button, { className: 'my-2 d-block me-auto', onClick: submit, variant: "success" }, "\u0627\u0646\u0634\u0627\u0621 \u0627\u0644\u0643\u062A\u0627\u0628"));
}
exports.default = BookCreator;
